/**
 * What the studio takes on.
 *
 * Four cells in a 2×2, hairlines inside and none on the outside. The order is
 * not the same in both languages: English opens with web platforms, Spanish
 * with Odoo, because that is what each market arrives looking for. The
 * dictionaries carry that order, so this component just renders what it is given.
 */
import { Section } from '../components/Section';
import { useI18n } from '../i18n';
import styles from './Services.module.css';

export function Services() {
  const { t } = useI18n();

  return (
    <Section
      id="services"
      eyebrow={t.services.eyebrow}
      title={t.services.title}
      lead={t.services.lead}
      tone="paper"
    >
      <div className={`grid ${styles.grid}`}>
        {t.services.items.map((item) => (
          <article key={item.label} className="cell">
            <p className={styles.label}>
              <span className={styles.num}>{item.num}</span>
              <span aria-hidden="true"> · </span>
              {item.label}
            </p>
            <h3 className={styles.title}>{item.title}</h3>
            <p className={styles.body}>{item.body}</p>
          </article>
        ))}
      </div>
    </Section>
  );
}
